import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, Sparkles, Clock, Mic, Settings, Brain } from 'lucide-react'

const SmartFeatures = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-pink-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link to="/" className="inline-flex items-center text-slate-600 hover:text-slate-900 mb-8 transition-colors duration-200 group">
          <ArrowLeft className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          返回主页
        </Link>
        
        <div className="mb-16">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-violet-500 to-purple-600 rounded-3xl mb-8 shadow-2xl">
            <Brain className="text-white w-12 h-12" />
          </div>
          <h1 className="text-6xl md:text-7xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
            智能功能与个性化设置
          </h1>
          <p className="text-2xl text-slate-600 max-w-3xl leading-relaxed">
            智能场景与个性化，让体验更贴心
          </p>
        </div>
        
        <div className="space-y-8">
          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-5 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-xl">
                <Sparkles className="text-white w-8 h-8" />
              </div>
              <h2 className="text-4xl font-bold text-slate-900">语境自动调控</h2>
            </div>
            <div className="prose prose-xl max-w-none text-slate-700 leading-relaxed">
              <div className="bg-gradient-to-br from-violet-50 to-purple-50 rounded-2xl p-8 mb-8 border border-violet-100">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-violet-600" />
                  功能介绍
                </h3>
                <p className="text-lg leading-relaxed mb-0">
                  设备联网后自动同步实时时间、本地天气，根据当下时段、天气自动调整对话语境、推荐内容、提醒话术，场景贴合度更高。
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Brain className="w-6 h-6 text-slate-600" />
                  使用场景
                </h3>
                <ul className="list-disc pl-8 space-y-3 mb-0 text-lg">
                  <li>清晨 7 点自动偏向早安问候、晨间轻音乐、今日天气播报</li>
                  <li>雨天会主动提醒出门带伞，推荐安静治愈歌曲</li>
                  <li>夜晚 22 点后切换轻柔低缓语调，推送助眠内容</li>
                  <li>高温酷暑天气对话会主动关心防暑降温</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-5 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl flex items-center justify-center shadow-xl">
                <Mic className="text-white w-8 h-8" />
              </div>
              <h2 className="text-4xl font-bold text-slate-900">多语态选择-专属音色定制</h2>
            </div>
            <div className="prose prose-xl max-w-none text-slate-700 leading-relaxed">
              <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-8 mb-8 border border-purple-100">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-purple-600" />
                  功能介绍
                </h3>
                <p className="text-lg leading-relaxed mb-4">
                  内置 6 套固定专属播报音色，涵盖：
                </p>
                <ul className="list-disc pl-8 space-y-3 mb-4 text-lg">
                  <li>萝莉音</li>
                  <li>少年音</li>
                  <li>温柔女声</li>
                  <li>沉稳男声</li>
                  <li>可爱童声</li>
                  <li>治愈播音腔</li>
                </ul>
                <p className="text-lg leading-relaxed mb-0">
                  可自由切换，适配不同使用偏好。支持用户专属音色复刻定制。
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Mic className="w-6 h-6 text-slate-600" />
                  使用示例
                </h3>
                <ul className="list-disc pl-8 space-y-3 mb-0 text-lg">
                  <li>语音指令：请切换"可爱童声"音色</li>
                  <li>语音指令：切换到第三种音色</li>
                  <li>长对话录制10秒钟以上的语音后，结尾给出语音指令："请复刻我的声音"</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-5 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-xl">
                <Clock className="text-white w-8 h-8" />
              </div>
              <h2 className="text-4xl font-bold text-slate-900">AI 时钟（闹钟、定时唤醒播报）</h2>
            </div>
            <div className="prose prose-xl max-w-none text-slate-700 leading-relaxed">
              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 mb-8 border border-blue-100">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-blue-600" />
                  功能介绍
                </h3>
                <p className="text-lg leading-relaxed mb-0">
                  集成智能闹钟定时系统，支持自定义多组闹钟，到点自动语音播报提醒，支持单次闹钟、每日重复闹钟，可搭配铃声、音乐作为闹铃。
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Clock className="w-6 h-6 text-slate-600" />
                  使用示例
                </h3>
                <ul className="list-disc pl-8 space-y-3 mb-0 text-lg">
                  <li>"设置明天早上 7 点的闹钟"</li>
                  <li>"每天晚上 9 点提醒我看书"</li>
                  <li>"关闭早上 7 点的闹钟"</li>
                  <li>"现在几点了，报一下今日天气"</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-5 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-600 rounded-2xl flex items-center justify-center shadow-xl">
                <Mic className="text-white w-8 h-8" />
              </div>
              <h2 className="text-4xl font-bold text-slate-900">唤醒词与自定义唤醒词</h2>
            </div>
            <div className="prose prose-xl max-w-none text-slate-700 leading-relaxed">
              <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl p-8 mb-8 border border-pink-100">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-pink-600" />
                  唤醒词功能介绍
                </h3>
                <p className="text-lg leading-relaxed mb-0">
                  产品处于自然待机状态时，用户只需轻声呼唤专属唤醒词——"你好，小乐悦"（nǐ hǎo，xiǎo yuè yuè），即可瞬时唤醒，实现零延迟语音响应，随即开启温暖自然的陪伴对话。
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8 mb-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Sparkles className="w-6 h-6 text-slate-600" />
                  自定义唤醒词功能介绍
                </h3>
                <p className="text-lg leading-relaxed mb-0">
                  支持设置专属唤醒口令，替代默认唤醒词，说出自定义词汇即可一键唤醒智能体，提升专属感，适配儿童、私人使用场景。
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4 flex items-center gap-3">
                  <Mic className="w-6 h-6 text-slate-600" />
                  使用方法
                </h3>
                <ul className="list-disc pl-8 space-y-3 mb-0 text-lg">
                  <li>通过配套管理工具录入自定义中文唤醒词（2-4 个字最佳）</li>
                  <li>设置完成后，待机状态下说出自定义唤醒词，即可直接开启对话</li>
                  <li>例：自定义 "小星辰"，待机喊 "小星辰" 就能唤醒</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-lg border border-slate-200 p-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex items-center gap-5 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-xl">
                <Settings className="text-white w-8 h-8" />
              </div>
              <h2 className="text-4xl font-bold text-slate-900">配套工具个性化设置</h2>
            </div>
            <div className="prose prose-xl max-w-none text-slate-700 leading-relaxed">
              <div className="bg-slate-50 rounded-2xl p-8">
                <ul className="list-disc pl-8 space-y-3 mb-0 text-lg">
                  <li>唤醒词修改：自定义专属唤醒口令</li>
                  <li>闹钟管理：新增、删除、修改定时闹钟</li>
                  <li>对话记录：查看历史聊天、演唱评测记录</li>
                  <li>音量调节：工具调节播放音量</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SmartFeatures
